import {
  Box,
  Grid,
  Typography,
  MenuItem,
  TextField,
  Checkbox,
} from "@mui/material";
import styles from "../../Candidates/Candidate.module.css";
import { customTextColor, whichFile } from "../../../utils/const";
import { CiMobile3 } from "react-icons/ci";
import { PiMailboxLight } from "react-icons/pi";
import { PiChairLight } from "react-icons/pi";
import { PiAddressBookLight } from "react-icons/pi";
import { PiNewspaperClippingLight } from "react-icons/pi";
import { PiIdentificationCardLight } from "react-icons/pi";
import { useNavigate, useLocation } from "react-router-dom";
import { PiUserLight } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import { PiMapPinSimpleAreaLight } from "react-icons/pi";
import { useEffect, useState } from "react";
import {
  addLocation,
  allLocation,
  getAllCountry,
  getAllState,
} from "../../../redux/common/locationSlice";
import {
  addWorkAuthorization,
  allWorkAuthorization,
} from "../../../redux/common/workAuthorizationSlice";
import { IoIosArrowRoundForward } from "react-icons/io";
import { useFormik } from "formik";
import * as Yup from "yup";
import Autocomplete from "@mui/material/Autocomplete";
import { resumeProcces } from "../../../redux/internal-tracking/InternalTrackerSlice";
import { addSkill, allSkill } from "../../../redux/common/skillSlice";
import { IoIosArrowRoundBack } from "react-icons/io";
import {
  addEducationSkill,
  addPersonalDetails,
} from "../../../redux/InternalStatic/internalCandidateStatic";
import { CiLinkedin } from "react-icons/ci";
import { PiBuildingsLight } from "react-icons/pi";
import { PiBookOpenUserLight } from "react-icons/pi";
import { PiInvoiceLight } from "react-icons/pi";

const work = [
  { value: "Onsite", label: "Onsite" },
  { value: "Hybrid", label: "Hybrid" },
  { value: "Remote", label: "Remote" },
  { value: "All", label: "All" },
];

const fieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "30px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "35px",
    fontSize: "14px ", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "35px",
    fontSize: "14px  ", // Adjust label position when it shrinks
  },
  padding: "7px",
};

const prefer_tax_term_bench = [
  { id: "contract", name: "Contract" },
  { id: "contract_to_hire", name: "Contract To Hire" },
];

const AddConsultant = ({ setMenuName, setMenuId }) => {
  const [selectedFileName, setSelectedFileName] = useState("");
  const [base64Resume, setBase64Resume] = useState();

  const [resumeError, setResumeError] = useState(false);

  const [locationIds, setLocationIds] = useState([]);
  const [workAuthorizeIds, setWorkAuthorizeIds] = useState([]);
  const resumeData = useSelector((state) => state.tracker.resumeData);
  const skillData = useSelector((state) => state.skill.data);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const workautho = useSelector((state) => state.workautho);
  const locations = useSelector((state) => state.location);
  const trackerLoading = useSelector((state) => state.tracker.status);

  const location = useLocation();
  const { row } = location.state || {};
  const { prevData } = location.state || {};
  const { returnSelectedFileName } = location.state || {};
  const personalDetails = useSelector(
    (state) => state.internalCandidateStatic.data
  );

  console.log({ selectedFileName });

  const formik = useFormik({
    initialValues: {
      full_name: row?.full_name || personalDetails?.full_name || "",
      current_job_title:
        row?.current_job_title || personalDetails?.current_job_title || "",
      total_experience:
        row?.total_experience || personalDetails?.total_experience || "",
      current_location:
        row?.current_location || personalDetails?.current_location || "",
      work_authorization:
        row?.work_authorization || personalDetails?.work_authorization || "",
      prefer_tax_team:
        row?.prefer_tax_team || personalDetails?.prefer_tax_team || [],
      mobile_no: row?.mobile_no || personalDetails?.mobile_no || "",
      alternative_mobile_no:
        row?.alternative_mobile_no ||
        personalDetails?.alternative_mobile_no ||
        "",
      email: row?.email || personalDetails?.email || "",
      prefer_location:
        row?.prefer_location || personalDetails?.prefer_location || [],
      resume: "",
      rate: row?.rate || personalDetails?.rate || "",
      highest_qualification:
        row?.highest_qualification ||
        personalDetails?.highest_qualification ||
        "",
      university: row?.university || personalDetails?.university || "",
      linkedin_profile_url:
        row?.linkedin_profile_url ||
        personalDetails?.linkedin_profile_url ||
        null,
      passing_year: row?.passing_year || personalDetails?.passing_year || "",
      work_preference:
        row?.work_preference || personalDetails?.work_preference || "",
      selectedFileName: null,
    },
    validationSchema: Yup.object({
      full_name: Yup.string().required("Full Name is required"),
      current_job_title: Yup.string().required("Job Title is required"),
      total_experience: Yup.string().required("Experience is required"),
      current_location: Yup.string().required("Current Location is required"),
      work_authorization: Yup.string().required(
        "Work Authorization is required"
      ),
      prefer_tax_team: Yup.array()
        .of(Yup.string())
        .min(1, "Prefer Tax term is required")
        .required("Prefer Tax term is required"),
      mobile_no: Yup.string().required("Mobile Number is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      prefer_location: Yup.array()
        .of(Yup.string())
        .min(1, "Prefer Location is required")
        .required("Prefer Location is required"),
      highest_qualification: Yup.string().required(
        "Highest Qualification is required"
      ),
      university: Yup.string().required("University is required"),
      passing_year: Yup.string().required("Passing Year is required"),
      rate: Yup.string().required("Rate is required"),
      work_preference: Yup.string().required("Work Preference is required"),
    }),
    onSubmit: (values) => {
      dispatch(addPersonalDetails(values));
      setMenuName("Skill and Experience");
      setMenuId(1);
    },
  });

  useEffect(() => {
    dispatch(addEducationSkill(resumeData?.data?.processed_json));
    if (resumeData && selectedFileName !== "") {
      formik.setFieldValue(
        "full_name",
        resumeData?.data?.processed_json?.name || ""
      );
      formik.setFieldValue(
        "total_experience",
        resumeData?.data?.processed_json?.total_experience || ""
      );
      formik.setFieldValue(
        "mobile_no",
        resumeData?.data?.processed_json?.phone || ""
      );
      formik.setFieldValue(
        "email",
        resumeData?.data?.processed_json?.email || ""
      );
      formik.setFieldValue(
        "linkedin_profile_url",
        resumeData?.data?.processed_json?.linkedin_profile_url || ""
      );

      formik.setFieldValue(
        "current_job_title",
        resumeData?.data?.processed_json?.job_profile || ""
      );

      formik.setFieldValue(
        "alternative_mobile_no",
        resumeData?.data?.processed_json?.alternate_contact || ""
      );

      formik.setFieldValue(
        "passing_year",
        resumeData?.data?.processed_json?.passing_year || ""
      );
      formik.setFieldValue(
        "highest_qualification",
        resumeData?.data?.processed_json?.highest_qualification || ""
      );
      formik.setFieldValue(
        "university",
        resumeData?.data?.processed_json?.university || ""
      );
    }
  }, [resumeData]);

  useEffect(() => {
    dispatch(allLocation());
    dispatch(allWorkAuthorization());
    dispatch(allSkill());
    dispatch(getAllCountry());
    dispatch(getAllState());
  }, []);

  useEffect(() => {
    formik.setFieldValue("selectedFileName", selectedFileName || "");
  }, [selectedFileName]);

  useEffect(() => {
    if (!resumeData || !locations) return;
    const checkAndAddLocation = async (locations, resumeData) => {
      const allLocation = locations?.data?.locations || [];
      const currentLocation =
        resumeData?.data?.processed_json?.current_location;

      if (!currentLocation) {
        console.error("Current location is not provided in resumeData.");
        return null;
      }

      const existingLocation = allLocation.find(
        (location) =>
          location.name.toLowerCase() === currentLocation.toLowerCase()
      );

      if (existingLocation) {
        console.log("Location found:", existingLocation);
        return existingLocation.id;
      } else {
        try {
          const newLocation = await dispatch(
            addLocation({ name: currentLocation })
          );
          return newLocation?.id || null;
        } catch (error) {
          console.error("Failed to add location:", error);
          throw new Error("Could not add location");
        }
      }
    };
    (async () => {
      const locationId = await checkAndAddLocation(locations, resumeData);
      console.log("Final Location ID:", locationId);
      setLocationIds(locationId);
    })();
  }, [resumeData]);

  useEffect(() => {
    if (!resumeData || !workautho) return;
    const checkAndAddLocation = async (workautho, resumeData) => {
      const allLocation = workautho?.data?.work_authorization_data || [];
      const currentLocation =
        resumeData?.data?.processed_json?.work_authorization;

      if (!currentLocation) {
        console.error("Current location is not provided in resumeData.");
        return null;
      }

      const existingLocation = allLocation.find(
        (location) =>
          location.name.toLowerCase() === currentLocation.toLowerCase()
      );

      if (existingLocation) {
        console.log("Location found:", existingLocation);
        return existingLocation.id;
      } else {
        try {
          const newLocation = await dispatch(
            addWorkAuthorization({ name: currentLocation })
          );
          return newLocation?.id || null;
        } catch (error) {
          console.error("Failed to add location:", error);
          throw new Error("Could not add location");
        }
      }
    };
    (async () => {
      const locationId = await checkAndAddLocation(workautho, resumeData);
      console.log("Final Location ID:", locationId);
      setWorkAuthorizeIds(locationId);
    })();
  }, [resumeData]);

  useEffect(() => {
    if (personalDetails?.current_location) {
      formik.setFieldValue(
        "current_location",
        personalDetails?.current_location
      );
    } else if (locationIds) {
      formik.setFieldValue("current_location", locationIds);
    }
  }, [locationIds, personalDetails]);

  useEffect(() => {
    if (personalDetails?.work_authorization) {
      formik.setFieldValue(
        "work_authorization",
        personalDetails?.work_authorization
      );
    } else if (workAuthorizeIds) {
      formik.setFieldValue("work_authorization", workAuthorizeIds);
    }
  }, [workAuthorizeIds, personalDetails]);

  useEffect(() => {
    setSelectedFileName(personalDetails?.selectedFileName);
  }, [personalDetails]);

  const handleFullNameChange = (event) => {
    const { value } = event.target;
    if (/^[a-zA-Z\s]*$/.test(value)) {
      formik.setFieldValue("full_name", value);
    }
  };

  const handleMobileNoChange = (e) => {
    const value = e.target.value;
    if (/^[\d\s.\-()+]*$/.test(value) && value.length <= 15) {
      formik.setFieldValue("mobile_no", value);
    }
  };

  const handleAlternativeMobileNoChange = (e) => {
    const value = e.target.value;
    if (/^[\d\s.\-()+]*$/.test(value) && value.length <= 15) {
      formik.setFieldValue("alternative_mobile_no", value);
    }
  };

  const handleButtonClick = () => {
    document.getElementById("fileInput").click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        const fileExtension = file.name.split(".").pop().toLowerCase();

        console.log({ fileExtension });

        const formattedBase64 = `data:${whichFile(
          fileExtension
        )};base64,${base64String}`;

        setBase64Resume(formattedBase64);

        // Set file name and prepare form data
        setSelectedFileName(file.name);
        const formData = new FormData();
        formData.append("resume_file", file);
        dispatch(resumeProcces(formData));
      };

      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    setSelectedFileName(returnSelectedFileName);
  }, [returnSelectedFileName]);

  useEffect(() => {
    if (prevData === undefined || prevData === null) {
      formik.setFieldValue("resume", base64Resume || null);
    } else {
      formik.setFieldValue("resume", prevData?.resume || null);
    }
    setResumeError(false);
  }, [base64Resume, prevData]);

  return (
    <Box className={styles.add_structure} sx={{ marginTop: "0" }}>
      <Typography
        className={styles.add_heading}
        style={{ color: customTextColor, padding: "0 15px" }}
      >
        <b> Candidate Details</b>
      </Typography>
      <Box className={styles.upload_resume_section} sx={{ marginTop: "0" }}>
        <Box style={{ color: customTextColor }}>
          <Typography> Be fast & get 100 credit on every candiadte</Typography>
          <Typography
            sx={{ marginBottom: "0 !important", fontSize: "20px !important" }}
          >
            Get 50% Extra Result in Recruitment Life
          </Typography>
        </Box>
        <div>
          <button
            onClick={handleButtonClick}
            disabled={trackerLoading === "loading"}
            style={
              trackerLoading === "loading"
                ? {
                    padding: "7px 40px",
                  }
                : {}
            }
          >
            {trackerLoading === "loading" ? "Loading" : "Upload Resume"}
          </button>
          <input
            id="fileInput"
            type="file"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          {selectedFileName && (
            <p
              style={{
                marginTop: "6px",
                fontSize: "14px",
                color: "#1b89de",
              }}
            >
              Selected file: {selectedFileName}
            </p>
          )}
          {resumeError === true ? (
            <div className={styles.error}>upload resume is required</div>
          ) : null}
        </div>
      </Box>

      <form onSubmit={formik.handleSubmit}>
        <Grid container className={styles.candidate_field_section}>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiUserLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Candidate Name"
              variant="standard"
              name="full_name"
              onChange={handleFullNameChange}
              onBlur={formik.handleBlur}
              value={formik.values.full_name}
              sx={fieldStyle}
            />
            {formik.touched.full_name && formik.errors.full_name ? (
              <div className={styles.error}>{formik.errors.full_name}</div>
            ) : null}
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <CiMobile3 style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Contact No"
              variant="standard"
              type="text"
              sx={fieldStyle}
              name="mobile_no"
              onChange={handleMobileNoChange}
              onBlur={formik.handleBlur}
              value={formik.values.mobile_no}
            />
            {formik.touched.mobile_no && formik.errors.mobile_no ? (
              <div className={styles.error}>{formik.errors.mobile_no}</div>
            ) : null}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <CiMobile3 style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Alternative Contact No (Optional)"
              variant="standard"
              type="text"
              name="alternative_mobile_no"
              onChange={handleAlternativeMobileNoChange}
              onBlur={formik.handleBlur}
              value={formik.values.alternative_mobile_no}
              sx={fieldStyle}
            />
            {formik.touched.alternative_mobile_no &&
            formik.errors.alternative_mobile_no ? (
              <div className={styles.error}>
                {formik.errors.alternative_mobile_no}
              </div>
            ) : null}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiMailboxLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="E-Mail ID"
              variant="standard"
              type="text"
              sx={fieldStyle}
              name="email"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            />
            {formik.touched.email && formik.errors.email ? (
              <div className={styles.error}>{formik.errors.email}</div>
            ) : null}
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiChairLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Current Job Profile"
              variant="standard"
              type="text"
              sx={fieldStyle}
              name="current_job_title"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.current_job_title}
            />
            {formik.touched.current_job_title &&
            formik.errors.current_job_title ? (
              <div className={styles.error}>
                {formik.errors.current_job_title}
              </div>
            ) : null}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiAddressBookLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Total Experience "
              variant="standard"
              type="text"
              sx={fieldStyle}
              name="total_experience"
              onChange={(e) => {
                const rawValue = e.target.value.replace(/[^0-9.]/g, ""); // Keep only numeric input
                formik.setFieldValue("total_experience", rawValue);
              }}
              // onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={
                formik.values.total_experience
                  ? `${formik.values.total_experience} ${
                      formik.values.total_experience > 1 ? "Years" : "Year"
                    }`
                  : ""
              }
              // value={formik.values.total_experience}
            />
            {formik.touched.total_experience &&
            formik.errors.total_experience ? (
              <div className={styles.error}>
                {formik.errors.total_experience}
              </div>
            ) : null}
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiIdentificationCardLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              select
              label="Work Authorization"
              variant="standard"
              name="work_authorization"
              sx={fieldStyle}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.work_authorization}
            >
              {workautho?.data?.work_authorization_data?.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
            {formik.touched.work_authorization &&
            formik.errors.work_authorization ? (
              <div className={styles.error}>
                {formik.errors.work_authorization}
              </div>
            ) : null}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 10px 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiNewspaperClippingLight style={{ fontSize: "25px" }} />
            </Box>

            <Autocomplete
              multiple
              id="autocomplete-multi-select"
              options={prefer_tax_term_bench || []}
              disableCloseOnSelect
              value={
                prefer_tax_term_bench?.filter((tax_term) =>
                  formik.values.prefer_tax_team?.includes(tax_term.id)
                ) || []
              }
              onChange={(event, value) => {
                const selectedPrefertaxterm = value?.map(
                  (tax_term) => tax_term?.id
                );
                formik.setFieldValue("prefer_tax_team", selectedPrefertaxterm);
              }}
              onBlur={formik.handleBlur}
              getOptionLabel={(option) => option?.name || ""}
              renderOption={(props, option, { selected }) => (
                <MenuItem {...props}>
                  <Checkbox
                    checked={selected}
                    sx={{ marginRight: 0, marginLeft: 0 }}
                  />
                  <span>{option?.name}</span>{" "}
                </MenuItem>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Prefer Tax Term"
                  variant="standard"
                  size="small"
                  name="prefer_tax_team"
                  sx={fieldStyle}
                />
              )}
              sx={{ backgroundColor: "#fff", width: "100%" }}
            />

            {formik.touched.prefer_tax_team && formik.errors.prefer_tax_team ? (
              <div className={styles.error}>
                {formik.errors.prefer_tax_team}
              </div>
            ) : null}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 10px 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiMapPinSimpleAreaLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              label="Currecnt Locations "
              variant="standard"
              select
              sx={fieldStyle}
              name="current_location"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.current_location}
            >
              {locations?.data?.locations?.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
            {formik.touched.current_location &&
            formik.errors.current_location ? (
              <div className={styles.error}>
                {formik.errors.current_location}
              </div>
            ) : null}
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ marginTop: "10px", padding: "0px 10px 10px" }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                position: "relative",
              }}
            >
              <Box className={styles.icon_style} style={{ left: "7px" }}>
                <PiMapPinSimpleAreaLight style={{ fontSize: "25px" }} />
              </Box>

              <Autocomplete
                multiple
                id="autocomplete-multi-select"
                options={locations?.data?.locations || []}
                disableCloseOnSelect
                value={
                  locations?.data?.locations?.filter((location) =>
                    formik.values.prefer_location?.includes(location.id)
                  ) || []
                }
                onChange={(event, value) => {
                  const selectedLocations = value?.map(
                    (location) => location?.id
                  );
                  formik.setFieldValue("prefer_location", selectedLocations);
                }}
                onBlur={formik.handleBlur}
                getOptionLabel={(option) => option?.name || ""}
                renderOption={(props, option, { selected }) => (
                  <MenuItem {...props}>
                    <Checkbox
                      checked={selected}
                      sx={{ marginRight: 0, marginLeft: 0 }}
                    />
                    <span>{option?.name}</span>{" "}
                  </MenuItem>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Preferred Location"
                    variant="standard"
                    size="small"
                    name="prefer_location"
                    sx={fieldStyle}
                  />
                )}
                sx={{ backgroundColor: "#fff", width: "100%" }}
              />
            </Box>
            {formik.touched.prefer_location && formik.errors.prefer_location ? (
              <div className={styles.error}>
                {formik.errors.prefer_location}
              </div>
            ) : null}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiBuildingsLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Work Preference"
              sx={fieldStyle}
              name="work_preference"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.work_preference}
              select
              variant="standard"
            >
              {work.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
            {formik.touched.work_preference && formik.errors.work_preference ? (
              <div className={styles.error}>
                {formik.errors.work_preference}
              </div>
            ) : null}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiInvoiceLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              label="Rate"
              sx={fieldStyle}
              name="rate"
              type="text"
              // onChange={handleChnageRate}
              onChange={(e) => {
                const rawValue = e.target.value.replace(/[^0-9.]/g, ""); // Keep only numeric input
                // formik.setFieldValue("rate", rawValue);
                if (rawValue.length <= 3) {
                  formik.setFieldValue("rate", rawValue); // Set value only if length <= 3
                }
              }}
              onBlur={formik.handleBlur}
              value={formik.values.rate ? `$${formik.values.rate} Hourly` : ""}
              // value={formik.values.rate}
              variant="standard"
            ></TextField>
            {formik.touched.rate && formik.errors.rate ? (
              <div className={styles.error}>{formik.errors.rate}</div>
            ) : null}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiBookOpenUserLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              label="Qualification"
              variant="standard"
              sx={fieldStyle}
              name="highest_qualification"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.highest_qualification}
            ></TextField>
            {formik.touched.highest_qualification &&
            formik.errors.highest_qualification ? (
              <div className={styles.error}>
                {formik.errors.highest_qualification}
              </div>
            ) : null}
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiBuildingsLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="University"
              variant="standard"
              type="text"
              sx={fieldStyle}
              name="university"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.university}
            />
            {formik.touched.university && formik.errors.university ? (
              <div className={styles.error}>{formik.errors.university}</div>
            ) : null}
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiBuildingsLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Passing year"
              variant="standard"
              type="number"
              name="passing_year"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.passing_year}
              sx={fieldStyle}
            />
            {formik.touched.passing_year && formik.errors.passing_year ? (
              <div className={styles.error}>{formik.errors.passing_year}</div>
            ) : null}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <CiLinkedin style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="LinkedIn URL (Optional)"
              variant="standard"
              type="text"
              sx={fieldStyle}
              name="linkedin_profile_url"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.linkedin_profile_url}
            />
          </Grid>
        </Grid>
      </form>

      <Box className={styles.add_consultant_btns}>
        <button
          onClick={() => navigate("/candidate-listing")}
          style={{
            border: "1.5px solid #4285f4",
            marginRight: "10px",
            padding: "6px 10px ",
            color: "#fff",
          }}
          disabled={trackerLoading === "loading"}
        >
          <IoIosArrowRoundBack style={{ fontSize: "25px", color: "#fff" }} />
        </button>
        <button
          onClick={formik.handleSubmit}
          disabled={trackerLoading === "loading"}
        >
          {trackerLoading === "loading" ? "Loading" : "Next Please"}
          <IoIosArrowRoundForward
            style={{ fontSize: "25px", marginLeft: "5px" }}
          />
        </button>
      </Box>
    </Box>
  );
};

export default AddConsultant;
